var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"name-no",class:{ 'name-no--inline': _vm.inline }},[_c('span',{staticClass:"name-no__name"},[_vm._v(_vm._s(_vm.name))]),(_vm.no)?_c('small',{staticClass:"name-no__no"},[_vm._v(_vm._s(_vm.no))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }